import React, { Component, Fragment } from 'react'
import Picture from '../../components/Picture'
import DemoForm from '../../components/site/Forms/DemoForm'
import DemoFormB2B from '../../components/site/Forms/DemoFormB2B'


const IMAGES = {
    'man-taking-notes': {
        url: '/images/site/landing-pages/order-system.png',
        alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        mobile: '/images/site/landing-pages/order-system-mobile.png'
    },
    'distribuidoras': {
        url: '/images/site/landing-pages/distribuidoras.png',
        alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        mobile: '/images/site/landing-pages/distribuidoras-mobile.png'
    },
    'man-looking-ipad': {
        url: '/images/site/landing-pages/sales-platform.png',
        alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        mobile: '/images/site/landing-pages/sales-platform-mobile.png'
    }
}

const QUOTES = {
    V1: {
        card1: "Vendas em catálogos virtuais para o mercado B2B devem alcançar mais de 6 trilhões de dólares em 2020",
        card2: "As vendas por catálogo B2B nos EUA crescem 7,7% ao ano e devem chegar a US$ 1.13 trilhões em 2020",
        card3: {
            quote1: "das compras são feitas fora do horário comercial",
            quote2: "das compras são feitas no final de semana",
            quote3: "dos acessos são feitos via celular",
        },
        card4: "20% dos clientes Mercos já faturam mais de 20% pelo catálogo B2B",
    },
    V2: {
        card1: "Pedidos online para o mercado B2B devem alcançar mais de 6 trilhões de dólares em 2020",
        card2: "Pedidos online B2B nos EUA crescem 7,7% ao ano e devem chegar a US$ 1.13 trilhões em 2020",
        card3: {
            quote1: "dos pedidos feitos no horário comercial",
            quote2: "das pedidos feitos no final de semana",
            quote3: "dos acessos são feitos via celular",
        },
        card4: "20% dos clientes Mercos já faturam mais de 20% emitindo pedidos online pelo e-commerce B2B",
    },
    V3: {
        card1: "Vendas por catálogo online para o mercado B2B devem alcançar mais de 6 trilhões de dólares em 2020",
        card2: "As vendas por catálogo online B2B nos EUA crescem 7,7% ao ano e devem chegar a US$ 1.13 trilhões em 2020",
        card3: {
            quote1: "das compras são feitas fora do horário comercial",
            quote2: "das compras são feitas no final de semana",
            quote3: "dos acessos são feitos via celular",
        },
        card4: <Fragment>20% dos clientes Mercos <strong>já faturam mais de 20%</strong> pelo catálogo online</Fragment>,
    },
};


export default class WhyUse extends Component {
    constructor(props) {
        super(props)
        this.reverse = this.props.reverse;
        this.sectionData = IMAGES[this.props.image] || {};
    }

    render() {
        const { variation = 'V1' } = this.props;
        const selectedQuotes = QUOTES[variation] || QUOTES['V1'];
        
        return (
            <Fragment>
                <section className='why-use'>
                    <div className={`container two-col  ${this.reverse ? 'reverse' : ''}`}>
                        <div className="column">
                            <h2 className={`${this.props.b2b ? 'title-light' : 'title'}`}>{this.props.title}</h2>
                            {this.props.b2b ? '' :
                                <Picture
                                    className='mobile-only'
                                    src={this.sectionData.mobile}
                                    alt={this.sectionData.alt}
                                    mobileSrc={this.sectionData.mobile ? this.sectionData.mobile : null}
                                />}
                            <div className="description">{this.props.children}</div>
                            {this.props.b2b ? <DemoFormB2B buttonOnly>saiba mais</DemoFormB2B> : <DemoForm inlineBtns trialAndDemo='teste grátis' modalLink />}

                        </div>
                        <div className="column">
                            {this.props.b2b ?
                                <Fragment>
                                    <div className="b2b-four-cards">
                                        <div className="card">
                                            <div className="quote">“{selectedQuotes.card1}”</div>
                                            <div className="company-logo"><img src="/images/site/landing-pages/b2b/frost-sullivan.png" alt="Frost Sullivan" /></div>
                                        </div>
                                        <div className="card">
                                            <div className="quote">“{selectedQuotes.card2}”</div>
                                            <div className="company-logo"><img src="/images/site/landing-pages/b2b/forrester.png" alt="Forrester" /></div>
                                        </div>
                                        <div className="card">
                                            <div className="v-quote"><div className="percent">20%</div> {selectedQuotes.card3.quote1}</div>
                                            <div className="v-quote"><div className="percent">10%</div> {selectedQuotes.card3.quote2}</div>
                                            <div className="v-quote"><div className="percent">40%</div> {selectedQuotes.card3.quote3}</div>
                                        </div>
                                        <div className="card">
                                            <div className="quote">“{selectedQuotes.card4}”</div>
                                            <div className="company-logo"><img src="/images/site/logo-mercos-colored.svg" alt="Mercos" width="110" /></div>
                                        </div>
                                    </div>

                                </Fragment>
                                :
                                <Picture
                                    className='desktop-only'
                                    src={this.sectionData.url}
                                    alt={this.sectionData.alt}
                                />
                            }
                            {this.props.b2b ? <DemoFormB2B buttonOnly>saiba mais</DemoFormB2B> : ''}
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}





// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/WhyUse.jsx